import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import MediaModal from "components/MediaModal";

import { Media } from "api";

const MediaPicker = ({ onChange, defaultSelectedMediaId }) => {
  const { t } = useTranslation();
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [mediaModalOpened, setMediaModalOpened] = useState(false);
  const [isHover, setIsHover] = useState(false);

  useEffect(async () => {
    if (defaultSelectedMediaId)
      try {
        const { data } = await Media.get(defaultSelectedMediaId);
        setSelectedMedia(data);
      } catch (error) {
        console.error(error);
      }
  }, [defaultSelectedMediaId])

  return (
    <>
      <MediaModal
        open={mediaModalOpened}
        onClose={({ selectedImage }) => {
          setSelectedMedia(selectedImage);
          onChange(selectedImage);
          setMediaModalOpened(false);
        }}
      />
      <SuiBox>
        <SuiBox ml={0.5} lineHeight={0} display="inline-block">
          <SuiTypography
            component="label"
            variant="caption"
            fontWeight="bold"
            textTransform="capitalize"
            style={{ cursor: selectedMedia ? "default" : "pointer" }}
            onClick={() => {
              setMediaModalOpened(true && !selectedMedia);
            }}
          >
            {t("Thumbnail")}
          </SuiTypography>
        </SuiBox>
      </SuiBox>
      <span
        role="button"
        tabIndex={0}
        onClick={() => {
          setMediaModalOpened(true && !selectedMedia);
        }}
        style={{
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: "#ddd",
          padding: "9px 15px",
          display: "block",
          fontSize: 14,
          borderRadius: 8,
          marginBottom: 20,
          cursor: selectedMedia ? "default" : "pointer",
        }}
      >
        {selectedMedia ? (
          <SuiBox style={{ lineHeight: 0 }}>
            <SuiBox style={{ position: "relative" }} display="inline-block"
              onMouseEnter={() => { setIsHover(true) }}
              onMouseLeave={() => { setIsHover(false) }}
            >
              <input
                type="image"
                src={selectedMedia.s3ObjKey.Location}
                alt=""
                style={{
                  maxHeight: 200,
                  width: "auto",
                  cursor: selectedMedia ? "default" : "pointer",
                  borderRadius: 8,
                  display: "inline-block",
                }}
              />
              <SuiButton variant="gradient" color="info"
                onClick={() => {
                  setSelectedMedia(null);
                  onChange(null);
                }}
                style={{
                  display: isHover ? "flex" : "none",
                  position: "absolute",
                  right: 10,
                  top: 10,
                  minWidth: "unset",
                  minHeight: "unset",
                  padding: "5px 10px",
                }}
              >
                X
              </SuiButton>
            </SuiBox>
          </SuiBox>
        ) : (
          t("Select a Thumbnail")
        )}
      </span>
    </>
  )
};

MediaPicker.defaultProps = {
  onChange: () => { },
};

MediaPicker.propTypes = {
  onChange: PropTypes.func,
  defaultSelectedMediaId: PropTypes.number,
};

export default MediaPicker;
